import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import { getHotelStatus } from "@/api/gameApi"

export default function HotelRestBanner() {
  const q = useQuery({
    queryKey: ["hotel-status-banner"],
    queryFn: getHotelStatus,
    refetchInterval: 60_000,
    staleTime: 30_000,
  })

  const status = q.data
  if (!status?.isResting) return null

  return (
    <Link
      to="/play/hotel"
      className="block border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-center text-xs text-amber-100"
    >
      Отдых в гостинице
      {status.restEndsAt
        ? ` до ${new Date(status.restEndsAt).toLocaleTimeString("ru-RU", {
            hour: "2-digit",
            minute: "2-digit",
          })}`
        : ""}
      {status.canCheckOut ? " · можно выселиться" : ""}
    </Link>
  )
}
